import { IBAN_COUNTRIES } from "../enum/ibanCountries";

export const validateSwiftBic = (value) => {
	if (!value || value.trim() === '') {
		return 'SWIFT / BIC code is required';
	}

	const trimmed = value.trim();

	// Check for lowercase letters
	if (/[a-z]/.test(trimmed)) {
		return 'SWIFT / BIC code must be in uppercase letters';
	}

	// Length must be 8 or 11
	if (!(trimmed.length === 8 || trimmed.length === 11)) {
		return 'SWIFT / BIC code must be either 8 or 11 characters long';
	}

	// First 4 must be letters
	if (!/^[A-Z]{4}/.test(trimmed)) {
		return 'The first 4 characters must be letters (bank code)';
	}

	// Next 2 must be letters (country code)
	if (!/^[A-Z]{4}[A-Z]{2}/.test(trimmed)) {
		return 'Characters 5 and 6 must be letters (country code)';
	}

	// Next 2 can be letters or digits (location code)
	if (!/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}/.test(trimmed)) {
		return 'Characters 7 and 8 must be letters or digits (location code)';
	}

	// Optional last 3 can be letters/digits (branch code)
	if (trimmed.length === 11 && !/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}[A-Z0-9]{3}$/.test(trimmed)) {
		return 'The last 3 characters (branch code) must be letters or digits';
	}

	return ''; // ✅ valid
};

export const validateBankIdentifier = (country, value) => {
	if (!value || value.trim() === '') {
		return 'This field is required';
	}

	// IBAN Countries
	if (IBAN_COUNTRIES.includes(country)) {
		const ibanRegex = /^[A-Z0-9]+$/; // Only uppercase letters + digits
		if (!ibanRegex.test(value)) {
			return 'IBAN must contain only uppercase letters and digits';
		}
		if (value.length < 15 || value.length > 34) {
			return 'IBAN must be between 15 and 34 characters';
		}
		return '';
	}

	// Country-specific cases
	switch (country) {
		case 'United States': {
			if (!/^\d+$/.test(value)) {
				return 'ABA routing number must contain only digits';
			}
			if (value.length !== 9) {
				return 'ABA routing number must be exactly 9 digits';
			}
			break;
		}

		case 'United Kingdom': {
			if (!/^\d+$/.test(value)) {
				return 'Sort code must contain only digits';
			}
			if (value.length !== 6) {
				return 'Sort code must be exactly 6 digits';
			}
			break;
		}

		case 'Australia': {
			if (!/^\d+$/.test(value)) {
				return 'BSB code must contain only digits';
			}
			if (value.length !== 6) {
				return 'BSB code must be exactly 6 digits';
			}
			break;
		}

		case 'Canada': {
			if (!/^\d+$/.test(value)) {
				return 'Transit number must contain only digits';
			}
			if (value.length !== 5) {
				return 'Transit number must be exactly 5 digits';
			}
			break;
		}

		default: {
			// Local Bank Identifier — 2–50 alphanumeric, spaces, or hyphens
			const localRegex = /^[A-Za-z0-9\s-]+$/;
			if (!localRegex.test(value)) {
				return 'Local bank identifier must be letters, numbers, spaces, or hyphens only';
			}
			if (value.length < 2 || value.length > 50) {
				return 'Local bank identifier must be between 2 and 50 characters';
			}
		}
	}

	return ''; // no error
};

